import 'sbf-design-system-component/social_widget/index';
import Overlay from 'sbf-design-system-component/overlays/overlay';

$(function () {
  $('a.download-form').click((e) => {
    window.open(e.target.dataset.href);
    return false;
  });

  const $gallery = $('#photo-gallery');
  const $next_button = $gallery.find('.next-button');
  const $previous_button = $gallery.find('.prev-button');
  let current_index = 0;

  const $overlay_photo = $('#overlay-photo');
  const $photo_counter = $('#photo-counter');
  const $photo_overlay = $('#photo-overlay');

  const $dummy_images = $('#photo-gallery-src .sbf-ce-section div');
  let $img_elements;
  const img_sources = $dummy_images.map(function () { return $(this).html(); }).get();
  const img_count = img_sources.length;
  const MAX_IMAGES = 10;
  const total_increments = Math.floor(img_count / MAX_IMAGES);

  let current_increment = 0;

  const $view_more_link = $('#view-more-photos-link');

  show_images(MAX_IMAGES);
  show_button();

  $gallery.on('click', 'img', function () {
    current_index = $img_elements.index(this);

    update_overlay();

    sbf.overlay.show('#photo-overlay');
  });

  $photo_overlay.on('click', '.next-button, #overlay-photo', function (e) {
    current_index++;
    if (current_index === img_count) {
      current_index = 0;
    }
    update_overlay();
    e.preventDefault();
  });

  $photo_overlay.on('click', '.prev-button', function (e) {
    current_index--;
    if (current_index < 0) {
      current_index = img_count - 1;
    }
    update_overlay();
    e.preventDefault();
  });

  $gallery.on('click', function (e) {
    $('#photo-gallery-src .sbf-ce-section').trigger('click');
    return false;
  });

  $('#hero-funds-organize-submit').on('click', function () {
    $(this).parents('form').submit();
    return false;
  });

  function update_overlay () {
    let overlay_height;
    let current_image_src = $dummy_images.eq(current_index).html();

    current_image_src = current_image_src.replace(/Thumb/gi, 'Full');

    $photo_counter.html((current_index + 1) + ' out of ' + img_count);
    $overlay_photo.attr('fetchpriority', 'high');
    $overlay_photo.attr('src', current_image_src);
    $overlay_photo.attr('alt', $img_elements.eq(current_index).attr('alt'));

    $overlay_photo.on('load', function () {
      sbf.overlay.refreshPosition();
    });

    overlay_height = $overlay_photo.height();
  }

  function show_images (count) {
    let html = '';
    for (let i = 0; i < img_count; i++) {
      if (i >= count) {
        break;
      }
      if (img_sources[i]) {
        html += '<div>';
        html += '<img class="lazyload" data-src="' + img_sources[i] + '" alt=""/>';
        html += '</div>';
      } else {
        break;
      }
    }
    $gallery.empty();
    $gallery.append(html);
    $img_elements = $gallery.find('img');
  }

  function show_button () {
    if (current_increment >= total_increments) {
      $view_more_link.hide();
      return;
    }

    $view_more_link.on('click', function (e) {
      current_increment++;
      if (current_increment === total_increments) {
        show_images(img_count);
        $view_more_link.hide();
      } else {
        show_images(MAX_IMAGES * (current_increment + 1));
      }
      e.preventDefault();
    });
  }

  /**
   * Workaround for showing the private event label and tooltip.
   */
  $('.private-event .entity-card .name').each(function () {
    const $this = $(this);
    $('<br/>').insertAfter(
      $('<span class="private-event-tooltip-button">?</span>').insertAfter(
        $('<span class="private-event-label">PRIVATE</span>').insertBefore($this)
      )
    );
  });

  privateEventToolTipButtonsAssignEventHandlers();
});

/**
 * Assign event handlers for private event tooltip buttons.
 *
 * @return    none
 */
const privateEventToolTipButtonsAssignEventHandlers = () => {
  $('.private-event .entity-card .private-event-tooltip-button').each(function () {
    privateEventTooltipButtonAssignEventHandlers($(this));
  });
};

/**
 * Assign event handlers for private event tooltip button.
 *
 * @param     object    $button    A jquery wrapped HTML element.
 * @return    none
 */
const privateEventTooltipButtonAssignEventHandlers = ($button) => {
  // Button - mouse enter event.
  $button.unbind('mouseenter').bind('mouseenter', function () {
    const $this  = $(this);
    const $popup = $('.private-event-tooltip-popoup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth   = $popup.width();
      const popupHeight  = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        'display': 'block',
        'top': buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        'left': buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $button.unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popoup').css('display', 'none');
  });
};

const fundHasPrivateEvent = $('.entity-item.private-event').length > 0;

if (fundHasPrivateEvent) {
  const privateEventCheckOverlay = new Overlay($('#private_event_check_overlay'), {
    full_screen: true,
    triggers: [$('.join-button')]
  });

  privateEventCheckOverlay.$el.on('overlay.afterShow', function () {
    const link = privateEventCheckOverlay.$trigger.attr('href');
    if (link) {
      $('#private-overlay__registration-button').attr('href', link);
    }
  });

  privateEventCheckOverlay.$el.find('.cancel').on('click', function () {
    privateEventCheckOverlay.hide();
  });
}
